module.exports = __webpack_public_path__ + "img/ic_help.26edac4a.svg";